export default "__VITE_ASSET__BlVbuS8c__"